/* unplugin-vue-components disabled */import script from "./Job.vue?vue&type=script&setup=true&lang=ts"
export * from "./Job.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__